/**
 * @file     listings.ts
 * @readme   ../CLAUDE.md
 * @purpose  Side-effect import: registers the English `listings` strings (owner listings: front door, builder, owner dashboard). Every file that references `listings.*` keys imports this (pnpm lint:i18n-deferred).
 */
import { listings } from '../resources/en/listings';
import { registerEnglish } from './registerEnglish';

registerEnglish({ listings });
